import React, { useEffect } from 'react';
import {
  CUSTOM_WEBHOOK_PROVIDER_CONFIG_VIEWS,
  DefaultWebhookProviderConfigView,
} from './webhook-provider-config-registry';
import type { WebhookProviderConfigViewProps } from '../types';
import { soleWebhookEventKeyToSelect } from '../webhook-config-draft';

export type { WebhookProviderConfigViewProps } from '../types';

function resolveWebhookProviderConfigView(
  providerKey: WebhookProviderConfigViewProps['catalog']['key']
): React.FC<WebhookProviderConfigViewProps> {
  const customView =
    CUSTOM_WEBHOOK_PROVIDER_CONFIG_VIEWS[
      providerKey as keyof typeof CUSTOM_WEBHOOK_PROVIDER_CONFIG_VIEWS
    ];
  if (customView !== undefined) {
    return customView;
  }
  return DefaultWebhookProviderConfigView;
}

export const WebhookProviderConfigSection: React.FC<
  WebhookProviderConfigViewProps
> = (props) => {
  const View = resolveWebhookProviderConfigView(props.catalog.key);
  const { onDraftChange } = props;
  // Done here rather than in each provider view so every flow that configures
  // a webhook — the trigger wizard, the workflow trigger drawer — gets it.
  const soleEventKey = soleWebhookEventKeyToSelect({
    events: props.catalog.events,
    selectedEventKey: props.draft.eventKey,
  });
  useEffect(() => {
    if (soleEventKey !== undefined) {
      onDraftChange({ eventKey: soleEventKey });
    }
  }, [soleEventKey, onDraftChange]);
  return <View {...props} />;
};

export {
  DefaultWebhookProviderConfigView,
  CUSTOM_WEBHOOK_PROVIDER_CONFIG_VIEWS,
};
